// import project1_1 from "../assets/project-1.1.png";
// import project1_2 from "../assets/project-1.2.png";
// import project2_1 from "../assets/project-2.1.png";
// import project2_2 from "../assets/project-2.2.png";
// const project1_2 = [mbsq11, mbsq12, mbsq13];

import mbsq7 from "../assets/images/moon_bar/sqr/PXL_20251120_123845399-EDIT.jpg";
import mbsq10 from "../assets/images/moon_bar/sqr/PXL_20251120_124712432-EDIT.jpg";
import mbvt2 from "../assets/images/moon_bar/vert/PXL_20251120_123638553.NIGHT-EDIT.jpg";

import mbsq3 from "../assets/images/moon_bar/sqr/PXL_20251120_122545006.jpg";
import mbsq6 from "../assets/images/moon_bar/sqr/PXL_20251120_123748142.NIGHT-EDIT.jpg";
import mbvt1 from "../assets/images/moon_bar/vert/PXL_20251120_122735050.NIGHT-EDIT.jpg";
import mbhr1 from "../assets/images/moon_bar/hory/PXL_20251120_122804700.NIGHT-EDIT.jpg";

import mbsq11 from "../assets/images/moon_bar/sqr/PXL_20251120_125127940-EDIT.jpg";
import mbsq13 from "../assets/images/moon_bar/sqr/PXL_20251120_130658733.NIGHT.jpg";

import mbsq5 from "../assets/images/moon_bar/sqr/PXL_20251120_123121399.NIGHT.jpg";
import mbsq9 from "../assets/images/moon_bar/sqr/PXL_20251120_124536884.jpg";
import mbsq4 from "../assets/images/moon_bar/sqr/PXL_20251120_122906617.NIGHT.jpg";
import mbhr3 from "../assets/images/moon_bar/hory/PXL_20251120_123316534-EDIT.jpg";
import mbhr4 from "../assets/images/moon_bar/hory/PXL_20251120_122705530~2.jpg";
import mbsq8 from "../assets/images/moon_bar/sqr/PXL_20251120_124015085-EDIT.jpg";
import mbhr2 from "../assets/images/moon_bar/hory/PXL_20251120_123052606.NIGHT-EDIT.jpg";

import mbsq2 from "../assets/images/moon_bar/sqr/PXL_20251120_122337263.jpg";
import mbvt3 from "../assets/images/moon_bar/vert/PXL_20251120_125659969.NIGHT.jpg";

// import mbsq12 from "../assets/images/moon_bar/sqr/PXL_20251120_130458113.NIGHT.jpg";
// import mbsq1 from "../assets/images/moon_bar/moon-main.jpg";

import bovt12 from "../assets/images/bothra_office/vert/PXL_20251108_075821223-EDIT.jpg";

import bosq2 from "../assets/images/bothra_office/hory/PXL_20251108_074207423-EDIT.jpg";
import bosq3 from "../assets/images/bothra_office/hory/PXL_20251108_074233909.jpg";
import bosq5 from "../assets/images/bothra_office/hory/PXL_20251108_074509939-EDIT.jpg";
import bosq6 from "../assets/images/bothra_office/hory/PXL_20251108_074625439.jpg";
import bovt5 from "../assets/images/bothra_office/vert/PXL_20251108_074438805.jpg";
import bovt6 from "../assets/images/bothra_office/vert/PXL_20251108_074449438-EDIT.jpg";
import bovt7 from "../assets/images/bothra_office/vert/PXL_20251108_074711278-EDIT.jpg";

import bosq4 from "../assets/images/bothra_office/hory/PXL_20251108_074310487.jpg";
import bosq10 from "../assets/images/bothra_office/hory/PXL_20251108_075719910.jpg";
import bovt11 from "../assets/images/bothra_office/vert/PXL_20251108_075653536-EDIT.jpg";

import bosq7 from "../assets/images/bothra_office/hory/PXL_20251108_075200654-EDIT.jpg";
import bovt9 from "../assets/images/bothra_office/vert/PXL_20251108_075120582.jpg";
import bovt10 from "../assets/images/bothra_office/vert/PXL_20251108_075255146-EDIT.jpg";

import bosq1 from "../assets/images/bothra_office/bothra-main.jpg";
import bovt1 from "../assets/images/bothra_office/vert/PXL_20251108_071921805.jpg";
import bovt2 from "../assets/images/bothra_office/vert/PXL_20251108_072432955-EDIT-EDIT.jpg";
import bovt3 from "../assets/images/bothra_office/vert/PXL_20251108_072605016-EDIT.jpg";
import bovt4 from "../assets/images/bothra_office/vert/PXL_20251108_073641830.jpg";

import bosq8 from "../assets/images/bothra_office/hory/PXL_20251108_075522578-EDIT.jpg";
import bosq9 from "../assets/images/bothra_office/hory/PXL_20251108_075551986-EDIT.jpg";
import bovt8 from "../assets/images/bothra_office/vert/PXL_20251108_074835128-EDIT.jpg";

import aosq2 from "../assets/images/apollo_office/hory/PXL_20251108_093015878.jpg";
import aosq3 from "../assets/images/apollo_office/hory/PXL_20251108_093034404.jpg";
import aosq4 from "../assets/images/apollo_office/hory/PXL_20251108_093104363.jpg";
import aosq5 from "../assets/images/apollo_office/hory/PXL_20251108_093159197.jpg";
import aosq6 from "../assets/images/apollo_office/hory/PXL_20251108_093228385.jpg";
import aosq7 from "../assets/images/apollo_office/hory/PXL_20251108_093254993.jpg";
import aosq10 from "../assets/images/apollo_office/hory/PXL_20251108_094149597.jpg";
import aovt1 from "../assets/images/apollo_office/verti/PXL_20251108_093504559.jpg";

import aosq1 from "../assets/images/apollo_office/hory/PXL_20251108_092944258.jpg";
import aovt6 from "../assets/images/apollo_office/verti/PXL_20251108_094055788-EDIT.jpg";

import aosq8 from "../assets/images/apollo_office/hory/PXL_20251108_094002808.jpg";
import aosq9 from "../assets/images/apollo_office/hory/PXL_20251108_094024538-EDIT.jpg";
import aosq11 from "../assets/images/apollo_office/hory/PXL_20251108_094301843-EDIT.jpg";
import aosq12 from "../assets/images/apollo_office/hory/PXL_20251108_094318324.jpg";
import aovt3 from "../assets/images/apollo_office/verti/PXL_20251108_093722014.jpg";
import aovt4 from "../assets/images/apollo_office/verti/PXL_20251108_093806068.jpg";

import aovt2 from "../assets/images/apollo_office/verti/PXL_20251108_093648816.jpg";
import aovt5 from "../assets/images/apollo_office/verti/PXL_20251108_093910541.jpg";

const project1 = [mbsq10, mbsq7];
const project1v = [mbvt2];
const project1_3 = [mbsq3, mbsq6, mbhr1];
const project1_3v = [mbvt1];
const project1_4 = [mbsq11, mbsq13];
const project1_5 = [mbsq5, mbsq9, mbsq4, mbhr3, mbhr4, mbsq8, mbhr2];
const project1_6 = [mbsq2];
const project1_6v = [mbvt3];

const project2 = [bovt12];
const project2_2 = [bosq2, bosq3, bosq5, bosq6];
const project2_2v = [bovt5, bovt6, bovt7];
const project2_3 = [bosq4, bosq10];
const project2_3v = [bovt11];
const project2_4 = [bosq7];
const project2_4v = [bovt9, bovt10];
const project2_5 = [bosq1];
const project2_5v = [bovt2, bovt1, bovt3, bovt4];
const project2_6 = [bosq8, bosq9,];
const project2_6v = [bovt8];

const project3 = [aosq2, aosq3, aosq4, aosq5, aosq6, aosq7, aosq10];
const project3v = [aovt1];
const project3_2 = [aosq1];
const project3_2v = [aovt6];
const project3_3 = [aosq8, aosq9, aosq11, aosq12];
const project3_3v = [aovt3, aovt4];
const project3_4 = [aovt2];
const project3_4v = [aovt5];

const moonbar = {
    title: "Moon Bar & Kitchen",
    location: "VIP Road, Visakhapatnam",
    scope: "Specialized Restoration & Renovation",
    objective: "Revitalizing the Atmosphere",
    // objective: "",
    execution: "This project demonstrates our capability in high-end maintenance and restoration. It highlights our attention to detail in handling specialized materials and our ability to execute a complete refresh of a hospitality space with speed and precision.",
    mandate: "For Moon Bar & Kitchen, ARC Studioz was tasked with a sensitive refurbishment mandate: to breathe new life into the venue’s signature elements without altering its iconic identity. The challenge was not to build anew, but to restore and refine the existing intricate features, requiring a deep understanding of materials ranging from epoxy resins to vintage joinery.",
    helightTitle: "Restoration Highlights",
    highlights: [
        {
            head: "Upholstery & Soft Furnishing Upgrade",
            content: "We breathed new life into the existing furniture inventory through a comprehensive re-upholstery program. By selecting premium, durable fabrics that complement the dark, moody atmosphere, we transformed worn seating into plush, inviting elements that elevate the tactile experience for every guest.",
            imagesSet: project1,
            imagesVSet: project1v
        },
        // {
        //     head: "Bespoke Furniture",
        //     content: "To enhance seating comfort and style, we manufactured custom-made sofas. Specifically for this space. Designed to withstand high-traffic hospitality use, these pieces were crafted to align perfectly with the venue's industrial-chic vibe, ensuring a cohesive look between the new additions and the existing furniture.",
        //     imagesSet: project1_2
        // },
        {
            head: "Epoxy Table Restoration",
            content: "The venue features complex resin 'river' tables that had seen significant wear. Our team executed a meticulous repair and polishing process, removing surface abrasions and restoring the optical clarity of the epoxy. We brought the finish back to a high-gloss, glass-like sheen, reviving the depth of the blue resin and the warmth of the embedded wood.",
            imagesSet: project1_3,
            imagesVSet: project1_3v
        },
        {
            head: "Door Refurbishment & Duco Finishing",
            content: "The vintage doors are a key aesthetic feature. We repaired the underlying joinery to ensure structural soundness and applied a fresh, premium Duco paint finish. This process involved careful surface preparation to retain the character of the doors while delivering a flawless, durable color coat that aligns with the venue's vibrant theme.",
            imagesSet: project1_4,
            imagesVSet: []
        },
        {
            head: "Preserving the Architectural Shell",
            content: "The site is defined by its existing complex brickwork, 'floating' wooden block ceiling, and dramatic lighting systems. Our role was to carefully clean, touch up, and maintain these features, ensuring the acoustic and visual integrity of the ceiling and the dramatic 'pin-spot' lighting effect remained undisturbed during the renovation process.",
            imagesSet: project1_5,
            imagesVSet: []
        },
        {
            head: "Neon & Art Integration",
            content: "We worked to ensure the retro-futuristic neon artworks and murals were seamlessly integrated into the refreshed surroundings, balancing the vibrancy of the art against the newly restored dark, moody finishes of the interior.",
            imagesSet: project1_6,
            imagesVSet: project1_6v
        }
    ]
}

const bothra = {
    title: "Bothra Shipping Corporate Office",
    location: "SAMPATH VINAYAK TEMPLE ROAD, VISAKHAPATNAM",
    scope: "Civil Execution & Turnkey Interiors",
    objective: "",
    execution: "The Bothra Shipping Head Office stands as a benchmark of our execution capabilities. It demonstrates our ability to manage large-scale corporate projects, from civil facade work to intricate interior finishes to deliver a seamless, move-in-ready headquarters.",
    mandate: "For the headquarters of Bothra Shipping, we served as the principal execution partner, charged with the responsibility of translating a sophisticated architectural vision into a tangible reality. This project required a comprehensive contracting approach, covering everything from the structural exterior facade to the finest interior details. Our role was to ensure that the high-performance design was delivered with absolute structural integrity and finishing precision.",
    helightTitle: "Execution Highlights",
    highlights: [
        {
            head: "Building Elevation & Façade Engineering",
            content: "We executed the building’s striking exterior elevation, a defining feature of the building. This involved the precise installation of the vertical louver systems and staggered structural elements that provide both solar shading and a modern aesthetic. Additionally, we fabricated and installed the external emergency staircase.",
            imagesSet: project2,
            imagesVSet: []
        },
        {
            head: "Executive Cabins & Workstations",
            content: "The interior execution focused on creating a hierarchy of privacy and collaboration. We managed the fit-out of open-plan workstations designed for productivity, alongside premium executive cabins enclosed in high-grade glass partitioning. Our team ensured seamless integration of electrical and data grid systems within the furniture and flooring to maintain a clutter-free environment.",
            imagesSet: project2_2,
            imagesVSet: project2_2v
        },
        {
            head: "Conference Rooms & Collaborative Spaces",
            content: "We delivered high-tech conference rooms and breakout lounges, focusing heavily on acoustic comfort and premium material application. From the installation of wooden flooring to the mounting of AV systems, every detail was managed to facilitate seamless communication.",
            imagesSet: project2_3,
            imagesVSet: project2_3v
        },
        {
            head: "Luxury Washrooms with Stretch Ceilings",
            content: "A standout feature of the facility is the executive washrooms. We executed complex wet-area detailing, including the installation of large-format stone cladding and premium sanitary ware. The highlight is the illuminated stretch ceiling system, which creates a diffuse, skylight-like effect, adding a touch of modern luxury to the amenities.",
            imagesSet: project2_4,
            imagesVSet: project2_4v
        },
        {
            head: "Dining & Recreational Zones",
            content: "Understanding the importance of employee well-being, we executed the dining areas and recreational zones with durable, high-traffic finishes. These spaces were fitted with custom joinery and robust lighting solutions to create a relaxed yet professional atmosphere.",
            imagesSet: project2_5,
            imagesVSet: project2_5v
        },
        {
            head: "Other Photos",
            content: "",
            imagesSet: project2_6,
            imagesVSet: project2_6v
        }
    ]
}

const apollo = {
    title: "Apollo Shipping Office",
    location: "Suryabagh, Visakhapatnam",
    scope: "Turnkey Interior Fit-out & Comprehensive MEP/IT Execution",
    objective: "",
    execution: "The Apollo Shipping project stands as a testament to our 'Plug-and-Play' contracting capabilities. By managing every aspect of the build—from the hidden fire safety pipes to the visible stretch ceilings—we delivered a workspace that was ready for business from day one.",
    mandate: "For the Apollo Shipping office, ARC Studioz served as the execution partner, tasked with transforming a bare shell into a fully operational corporate office. This project was an exercise in technical integration, where high-end aesthetic finishes had to coexist seamlessly with a heavy-duty infrastructure backbone. Our role was to execute the architect's vision with absolute fidelity while ensuring the functional systems behind the walls were robust and future-proof.",
    helightTitle: "Interior Execution Highlights",
    highlights: [
        {
            head: "Operational & Executive Zones",
            content: "We managed the complete fit-out of the open-plan workstations and private Manager Cabins. This involved the precise installation of glass partitioning systems to maintain visual connectivity while ensuring acoustic privacy. The layout was executed to maximize workflow efficiency without compromising on the spatial quality.",
            imagesSet: project3,
            imagesVSet: project3v
        },
        {
            head: "The Conference Room & Stretch Ceiling",
            content: "The centerpiece of the office is the main conference room, where we installed a premium illuminated stretch ceiling. This specialized installation provides uniform, shadow-less lighting essential for video conferencing and presentations, adding a sleek, modern aesthetic to the meeting space.",
            imagesSet: project3_2,
            imagesVSet: project3_2v
        },
        {
            head: "Reception & Amenities",
            content: "We executed the Reception and Waiting Lounge, featuring custom joinery and integrated branding elements. Additionally, we executed the Cafeteria and Washrooms with high-durability finishes and premium sanitary fixtures to ensure comfort and longevity.",
            imagesSet: project3_3,
            imagesVSet: project3_3v
        },
        {
            head: "Other Photos",
            content: "",
            imagesSet: project3_4,
            imagesVSet: project3_4v
        },
        {
            head: "The Hidden Architecture: MEP & IT Infrastructure",
            content: "What makes this project a benchmark for ARC Studioz is the scope of the 'invisible' work we executed:",
            imagesSet: [],
            imagesVSet: []
        },
        {
            head: "Structured Cabling & IT",
            content: "We installed the entire data backbone, including high-speed Ethernet cabling and a comprehensive electrical grid to support heavy operational loads.",
            imagesSet: [],
            imagesVSet: []
        },
        {
            head: "Security & Safety",
            content: " A fully integrated CCTV network was mapped and installed for total premise security, alongside a rigorous Fire Safety System that meets all statutory compliance standards.",
            imagesSet: [],
            imagesVSet: []
        },
        {
            head: "Climate & Plumbing",
            content: "We executed the complete HVAC (Air Conditioning) and plumbing system, ensuring optimal climate control and water management throughout the facility.",
            imagesSet: [],
            imagesVSet: []
        }
    ]
}

export const PROJECTS_MAP = {
    moonbar,
    bothra,
    apollo,
};

export const gallaryImages = {
    gallaryHImgs: [mbsq5, mbsq3, mbsq10, mbsq7, mbhr4, mbsq8, mbhr2, bosq5, bosq1, bosq8, bosq9, aosq2, aosq6, aosq7, aosq8, aosq11, aosq12],
    gallaryVImgs: [mbsq2, mbvt1, bovt7, bosq7, bovt9, bovt10, bovt2, bovt3, bovt4, bovt8, aovt1, aovt6, aovt4]
}
export const arcStudiozAddress = "58-1-235/116, E Block 302, Tarakarama Enclave, shanthi Nagar, NAD junction, Visakhapatnam, Andhra Pradesh - 530037, India."